import { createSelector, ParametricSelector } from 'reselect'
import { ReduxState } from 'store/createRootReducer'
import { EternalListEnum, EternalListsState } from '../types'

const getListFeature: ParametricSelector<ReduxState, EternalListEnum, EternalListsState[EternalListEnum]> = (state, list) => {
  return state.eternalLists[list]
}

export const listFeatureStateSelector = createSelector(getListFeature, listFeature => listFeature)
